<template>
  <div class="foot-box">
    <div class="empty"></div>
    <div class="tarbars">
      <div class="tab" v-for="(item, index) in list" :key="index" @click="onRouter(item)">
          <div class="tab-img-box">
            <img
              class="tab-img"
              :src="item.selectedIconPath"
              v-if="$route.path === item.pagePath || $route.name === item.name"
            />
            <img class="tab-img" :src="item.iconPath" v-else />
          </div>
          <div
            class="tab-text"
            :class="{ 'active': $route.path === item.pagePath || $route.name === item.name}"
          >
            {{ item.text }}
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TabbarComponent",
  data() {
    return {
      list: [
        {
          pagePath: "/",
          text: "首页",
          iconPath: require("../assets/images/icons/home0.png"),
          selectedIconPath: require("../assets/images/icons/home1.png"),
          name: 'acting'
        },
        {
          pagePath: "/list",
          text: "选购",
          iconPath: require("../assets/images/icons/list0.png"),
          selectedIconPath: require("../assets/images/icons/list1.png"),
        },
        {
          pagePath: "/cart",
          text: "购物车",
          iconPath: require("../assets/images/icons/cart0.png"),
          selectedIconPath: require("../assets/images/icons/cart1.png"),
        },
        {
          pagePath: "/user",
          text: "我的",
          iconPath: require("../assets/images/icons/user0.png"),
          selectedIconPath: require("../assets/images/icons/user1.png"),
        },
      ],
    };
  },
  methods: {
    onRouter(item) {
      this.$router.push(item.pagePath);
    },
  },
};
</script>
<style lang="scss" scoped>
.tarbars,
.empty {
  height: 41px;
}
.tarbars {
  border-top: solid 1px #efefef;
  height: 41px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    .tab-img-box {
      .tab-img {
        width: 16px;
        height: 16px;
      }
    }
    .tab-text {
      font-size: 14px;
      color: #999999;
    }
    .tab-text.active {
      color: #000000;
    }
  }
}
</style>
